<script>
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'RangeChart',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.0.0',
                    desc: 'Range Chart',
                    preset: {
                        name: 'RangeChart',
                        side: 'onchart',
                        settings: {
                            rangeSize: 'auto',
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length < 2) return

                let rangeSize = this.getRangeSize(candles)
                if (rangeSize <= 0) return

                // Build range bars from candle data
                let rangeBars = this.buildRangeBars(candles, rangeSize, layout)

                // Render range bars
                for (var i = 0, n = rangeBars.length; i < n; i++) {
                    this.drawRangeBar(ctx, rangeBars[i])
                }
            },
            buildRangeBars(candles, rangeSize, layout) {
                let bars = []
                let currentOpen = candles[0].raw[1]
                let currentHigh = candles[0].raw[2]
                let currentLow = candles[0].raw[3]
                let barStartIdx = 0

                for (var i = 0, n = candles.length; i < n; i++) {
                    let c = candles[i]
                    let high = c.raw[2]
                    let low = c.raw[3]

                    currentHigh = Math.max(currentHigh, high)
                    currentLow = Math.min(currentLow, low)

                    // Check if range exceeds the target
                    if (currentHigh - currentLow >= rangeSize) {
                        let close = c.raw[4]
                        let green = close >= currentOpen

                        // Use the midpoint x position of the bar's candle range
                        let midIdx = Math.floor((barStartIdx + i) / 2)
                        let midCandle = candles[Math.min(midIdx, candles.length - 1)]
                        let barW = candles[i].w

                        let yOpen = Math.floor(currentOpen * layout.A + layout.B)
                        let yHigh = Math.floor(currentHigh * layout.A + layout.B)
                        let yLow = Math.floor(currentLow * layout.A + layout.B)
                        let yClose = Math.floor(close * layout.A + layout.B)

                        bars.push({
                            x: midCandle.x,
                            w: barW * 1.2,
                            o: yOpen,
                            h: yHigh,
                            l: yLow,
                            c: yClose,
                            green: green
                        })

                        // Start new bar
                        currentOpen = close
                        currentHigh = close
                        currentLow = close
                        barStartIdx = i + 1
                    }
                }

                // Add incomplete final bar
                if (barStartIdx < candles.length) {
                    let lastCandle = candles[candles.length - 1]
                    let close = lastCandle.raw[4]
                    let green = close >= currentOpen
                    let midIdx = Math.floor((barStartIdx + candles.length - 1) / 2)
                    let midCandle = candles[Math.min(midIdx, candles.length - 1)]

                    bars.push({
                        x: midCandle.x,
                        w: lastCandle.w * 1.2,
                        o: Math.floor(currentOpen * layout.A + layout.B),
                        h: Math.floor(currentHigh * layout.A + layout.B),
                        l: Math.floor(currentLow * layout.A + layout.B),
                        c: Math.floor(close * layout.A + layout.B),
                        green: green
                    })
                }

                return bars
            },
            drawRangeBar(ctx, bar) {
                let color = bar.green ? this.upColor : this.downColor
                let w = Math.max(bar.w, 1)
                let hw = Math.max(Math.floor(w * 0.5), 1)
                let x05 = Math.floor(bar.x) - 0.5

                // Draw wick
                ctx.strokeStyle = color
                ctx.beginPath()
                ctx.moveTo(x05, Math.floor(bar.h))
                ctx.lineTo(x05, Math.floor(bar.l))
                ctx.stroke()

                // Draw body
                let h = Math.abs(bar.o - bar.c)
                let max_h = bar.c === bar.o ? 1 : 2
                let s = bar.green ? 1 : -1

                if (w > 1.5) {
                    ctx.fillStyle = color
                    ctx.fillRect(
                        Math.floor(bar.x - hw - 1),
                        bar.c,
                        Math.floor(hw * 2 + 1),
                        s * Math.max(h, max_h)
                    )
                } else {
                    ctx.strokeStyle = color
                    ctx.beginPath()
                    ctx.moveTo(x05, Math.floor(Math.min(bar.o, bar.c)))
                    ctx.lineTo(x05, Math.floor(Math.max(bar.o, bar.c)) + (bar.o === bar.c ? 1 : 0))
                    ctx.stroke()
                }
            },
            getRangeSize(candles) {
                if (this.sett.rangeSize && this.sett.rangeSize !== 'auto') {
                    return parseFloat(this.sett.rangeSize)
                }
                // Auto: use 2x ATR
                let sum = 0
                for (var i = 0, n = candles.length; i < n; i++) {
                    sum += candles[i].raw[2] - candles[i].raw[3]
                }
                return (sum / candles.length) * 2
            },
            use_for() { return ['RangeChart'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
